import buildService from '../../helper/service'

// 值类型为String或Object,String为url(method),Object同axios(config)参数支持相同,data和params只能为对象类型
const settings = {
  // 编码规则树
  getEncodeTree: {
    url: '/adminc/v1/ruleCode_manage/b_rule_code_resolve/get_resolve_list',
    method: 'get'
  },
  // 编码规则树-添加
  createEncodeTree: {
    url: '/adminc/v1/ruleCode_manage/b_rule_code_resolve/create_code_resolve',
    method: 'post'
  },
  // 编码规则树-修改
  updateEncodeTree: {
    url: '/adminc/v1/ruleCode_manage/b_rule_code_resolve/update_code_resolve',
    method: 'put'
  },
  // 编码规则树-删除
  deleteEncodeTree: {
    url: '/adminc/v1/ruleCode_manage/b_rule_code_resolve/delete_code_resolve',
    method: 'delete'
  },
  // 获取规则段列表
  getRuleSectionList: {
    url: '/adminc/v1/ruleCode_manage/b_rule_code/get_rule_list',
    method: 'get'
  },
  // 规则段-添加
  createRuleSection: {
    url: '/adminc/v1/ruleCode_manage/b_rule_code/create_rule',
    method: 'post'
  },
  // 规则段-修改
  updateRuleSection: {
    url: '/adminc/v1/ruleCode_manage/b_rule_code/update_rule',
    method: 'put'
  },
  // 规则段-删除
  deleteRuleSection: {
    url: '/adminc/v1/ruleCode_manage/b_rule_code/delete_rule',
    method: 'delete'
  },
  // 获取流水段列表
  getFlowList: {
    url: '/adminc/v1/ruleCode_manage/b_pipeline_section/get_section_list',
    method: 'get'
  },
  // 流水段-添加
  createFlowSection: {
    url: '/adminc/v1/ruleCode_manage/b_pipeline_section/create_section',
    method: 'post'
  },
  // 流水段-删除
  deleteFlowSection: {
    url: '/adminc/v1/ruleCode_manage/b_pipeline_section/delete_section',
    method: 'delete'
  },
  // 编码规则-模拟生成
  encodeSimulate: {
    url: '/adminc/v1/ruleCode_manage/b_rule_code_record/create_apply_rule',
    method: 'post'
  },
  // 编码使用记录
  encodeRecord: {
    url: '/adminc/v1/ruleCode_manage/b_rule_code_record/get_code_record_list',
    method: 'get'
  }
}

export default buildService(settings)



// WEBPACK FOOTER //
// ./src/services/EncodeRule/EncodeRule.js